import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7842573a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "item_table" }
const _hoisted_5 = { class: "item_image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AndroidOutlined = _resolveComponent("AndroidOutlined")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 软硬一体机 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_tabs, {
          tabPosition: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?'left':'top'
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: item.title,
                tab: item.title
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: 24,
                        md: 24,
                        lg: 24
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["item", `box_${index+1} ${_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?'item_large':'item_small'}`])
                          }, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_a_table, {
                                dataSource: item.dataSource,
                                columns: item.columns,
                                size: "small",
                                pagination: false
                              }, null, 8 /* PROPS */, ["dataSource", "columns"])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_a_image, {
                                src: item.image
                              }, null, 8 /* PROPS */, ["src"])
                            ])
                          ], 2 /* CLASS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tab"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["tabPosition"])
      ]),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToAidigitalHuman())),
            style: {"width":"135px !important"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费试用(SaaS) ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$FN.JumpDownloadApk())),
            style: {"width":"135px !important"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 下载客户端 "),
              _createVNode(_component_AndroidOutlined)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            class: "button_n_2",
            type: "link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','productAidigitalHuman')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 联系我们 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}